;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';

import cx from 'clsx';

import Text from 'components/ui/Text';

import styles from './TalesBlockHeader.module.scss';

const TalesBlockHeader = ({ eyebrow, headline, isActive }) => {
    const rootRef = useRef(null);
    const [isInView, setIsInView] = useState(false);

    const intersection = useIntersection(rootRef, {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    });

    useEffect(() => {
        if (intersection?.isIntersecting && isActive) {
            setIsInView(true);
        }

        if (!isActive) {
            setIsInView(false);
        }
    }, [intersection, isActive]);

    return (
        <section
            ref={rootRef}
            className={cx(styles.root, {
                [styles.isInView]: isInView,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.lockup}>
                    <div className={styles.lockupEyebrow}>
                        <div className={styles.svgContainerBefore}>
                            <svg
                                width="65"
                                height="18"
                                viewBox="0 0 65 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M32.9227 11.4465C32.0514 11.4465 30.9324 11.4277 28.7918 11.564C24.9795 11.8132 20.8044 13.4868 19.8712 17.793L0.703125 17.793L7.27529 9.00191L0.703125 0.206165L19.8712 0.206165C20.8 4.51237 24.9795 6.19066 28.7918 6.43512C30.9324 6.57145 32.0514 6.55264 32.9227 6.55264C33.7143 6.55264 64.5169 6.55264 64.5169 6.55264L64.5125 11.4418C64.5125 11.4418 33.2367 11.4465 32.9227 11.4465Z"
                                    fill="#FCFAE6"
                                />
                            </svg>
                        </div>
                        <Text className={styles.eyebrow} baseTheme="labelSmall">
                            {eyebrow}
                        </Text>
                        <div className={styles.svgContainerAfter}>
                            <svg
                                width="68"
                                height="20"
                                viewBox="0 0 68 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.515625 12.4501L0.515625 7.55627C0.515625 7.55627 34.3999 7.55627 49.1098 7.55627C48.6853 5.05059 47.6282 2.77996 46.1201 0.937128C45.983 0.772589 46.151 0.528131 46.3456 0.612751L67.2961 10.0055L46.3412 19.3889C46.1511 19.4736 45.983 19.2291 46.1157 19.0646C47.6282 17.2217 48.6809 14.9511 49.1054 12.4454C49.1099 12.4501 0.515625 12.4501 0.515625 12.4501Z"
                                    fill="#FCFAE6"
                                />
                            </svg>
                        </div>
                    </div>
                    <Text className={styles.headline} baseTheme="displayMedium">
                        <span dangerouslySetInnerHTML={{ __html: headline }} />
                    </Text>
                </div>
            </div>
        </section>
    );
};

export default TalesBlockHeader;
